import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingScreen from './LoadingScreen';

/** Redirect to an absolute URL, or fall back to an in-app path. */
export default function ExternalRedirect({ url, fallback = '/', label = 'Redirecting…' }) {
  useEffect(() => {
    if (url && /^https?:\/\//i.test(url)) {
      window.location.assign(url);
    }
  }, [url]);

  if (url && /^https?:\/\//i.test(url)) {
    return <LoadingScreen label={label} />;
  }

  return <Navigate to={fallback} replace />;
}
